export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversations.manage',
  'conversations.view_unassigned',
  'conversations.view_participating',
  'contacts.manage',
  'reports.overview.view',
  'help_center.manage',
];

export const CONVERSATION_PERMISSIONS = [
  'conversations.view_own',
  'conversations.view_all',
  'conversations.view_mentions',
  'conversations.view_participating',
  'conversations.view_unassigned',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversations.manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversations.view_unassigned';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversations.view_participating';

export const CONTACT_PERMISSIONS = 'contacts.view';

export const REPORTS_PERMISSIONS = 'reports.overview.view';

export const PORTAL_PERMISSIONS = 'help_center.view';

export const canFilterConversations = (permissions, isLabelView = false) => {
  const canFilterGeneralConversations = permissions.includes(
    'conversations.filter'
  );

  return (
    canFilterGeneralConversations &&
    (!isLabelView || permissions.includes('labels.conversations_filter'))
  );
};

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: ['conversations.view_own'],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: ['conversations.view_unassigned'],
  },
  all: {
    count: 'allCount',
    permissions: ['conversations.view_all'],
  },
};
